module.exports = __webpack_public_path__ + "img/profit_detail_m_grey.e4ed1b05.svg";